import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredSweepsCoin = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <ellipse
      cx={6.80702}
      cy={7.01522}
      rx={6.47364}
      ry={6.65145}
      fill="#4AC900"
    />
    <ellipse
      cx={7.19301}
      cy={6.98482}
      rx={6.47364}
      ry={6.65145}
      fill="#5EFF00"
    />
    <ellipse
      cx={7.18271}
      cy={6.98486}
      rx={5.08371}
      ry={5.2207}
      fill="#4AC900"
    />
    <ellipse
      cx={6.98489}
      cy={6.98486}
      rx={4.91629}
      ry={5.2207}
      fill="#57EB00"
      fillOpacity={0.8}
    />
    <g filter="url(#filter0_d_8239_53)">
      <path
        d="M9.95774 3.8964C9.1655 3.27317 8.29932 3.01965 7.19019 3.01965C5.62684 3.01965 4.09518 3.6957 4.09518 5.25904C4.09518 7.09704 5.48952 7.509 7.10568 7.65688C7.91905 7.73083 8.34158 7.96322 8.34158 8.33293C8.34158 8.74489 7.86623 8.98784 7.17963 8.98784C6.5564 8.98784 5.74304 8.86108 5.01418 8.15335L3.86279 9.47375C4.88742 10.5512 5.8381 10.7836 7.16906 10.773C8.82748 10.7625 10.412 10.0442 10.412 8.36462C10.412 6.66395 8.8803 6.07241 7.41202 5.91396C6.68316 5.84002 6.18669 5.76608 6.18669 5.25904C6.18669 4.86821 6.68316 4.70976 7.19019 4.70976C7.83454 4.70976 8.41552 4.83652 8.92255 5.21679L9.95774 3.8964Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_8239_53"
        x={3.86279}
        y={3.01965}
        width={6.54919}
        height={8.75366}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_8239_53"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_8239_53"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColouredSweepsCoin)
const IconSvgColouredSweepsCoin = createIcon(
  ForwardRef,
  'SvgColouredSweepsCoin',
)
export default IconSvgColouredSweepsCoin
